import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ImageUploadModule, SharedModule } from '../shared.module';
import { ConfirmModalComponent } from './component/confirm-modal/confirm-modal.component';
import { DynamicTableFormComponent } from './component/dynamic-table-form/dynamic-table-form.component';
import { FormDocComponent } from './component/form-doc/form-doc.component';
import { FormGeneratorComponent } from './component/form-generator/form-generator.component';
import { TableListComponent } from './component/table-list/table-list.component';
import { ConditionOperatorPipe } from './pipe/condtion-operator.pipe';
import { CurrencyFormatPipe } from './pipe/currency-format.pipe';
import { FormControlActionPipe } from './pipe/form-control-action.pipe';
import { TransformArrayPipe } from './pipe/transform-array.pipe';
import { SafeHtmlPipe } from 'src/app/editor/pipe/safe-html.pipe';
import { DataListComponent } from './component/data-list/data-list.component';
import { ScrollerModule } from 'primeng/scroller';
import { InputTextModule } from 'primeng/inputtext';
import { DataviewComponent } from './component/dataview/dataview.component';
import { DataViewModule } from 'primeng/dataview';
import { KeyFilterModule } from 'primeng/keyfilter';
import { LazyLoadListComponent } from './component/lazy-load-list/lazy-load-list.component';
import { PasswordModule } from 'primeng/password';

@NgModule({
    declarations: [
        ConfirmModalComponent,
        FormGeneratorComponent,
        TableListComponent,
        ConditionOperatorPipe,
        TransformArrayPipe,
        FormControlActionPipe,
        DynamicTableFormComponent,
        FormDocComponent,
        CurrencyFormatPipe,
        SafeHtmlPipe,
        DataListComponent,
        DataviewComponent,
        LazyLoadListComponent,
    ],
    providers: [ConditionOperatorPipe], exports: [FormGeneratorComponent, FormDocComponent, TableListComponent, ConditionOperatorPipe, DynamicTableFormComponent, CurrencyFormatPipe, SafeHtmlPipe, DataListComponent, DataviewComponent, LazyLoadListComponent],
    imports: [
        CommonModule,
        MultiSelectModule,
        TableModule,
        DropdownModule,
        AutoCompleteModule,
        ColorPickerModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        ImageUploadModule,
        ChipsModule,
        SharedModule,
        ScrollerModule,
        InputTextModule,
        DataViewModule,
        KeyFilterModule,
        PasswordModule
    ]
})
export class FormHelperModule { }
